import React from 'react';
import { NavLink, Link, withRouter } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faSignOutAlt, faSignInAlt, faUsersCog, faHome, faUser } from '@fortawesome/free-solid-svg-icons';

import AdminGroupSelect from 'Components/Partials/AdminGroupSelect';

import User from 'Services/User';
import { asset, filterItemsByAccess } from 'Services/BaseHelpers';

class Header extends React.Component {
    /**
     * @var navItems
     * @type {array}
     */
    navItemsLeft = [
        {
            to: "/main-stage",
            title: "Live",
            is_logged_in: true
        },
        {
            to: "/on-demand",
            title: "On-Demand",
            is_logged_in: true
        },
        {
            to: "/main-stage/test-stream",
            title: "Test Feed",
            is_logged_in: true
        },
        {
            to: "/speakers",
            title: "Speakers",
            feature: "allow_profile_change",
            is_logged_in: true
        },
    ];

    /**
     * @var navItems
     * @type {array}
     */
    navItemsRight = [
        {
            to: "/agenda",
            title: "Agenda",
            is_logged_in: true
        },
        {
            to: "/celebration-wall",
            title: "Activity Wall",
            is_logged_in: true
        },
/*        {
            to: "/settings/profile",
            title: "Registration",
            feature: "allow_profile_change",
            is_logged_in: true
        },*/
        {
            to: "/profile",
            title: "Profile",
            feature: "allow_profile_change",
            is_logged_in: true
        },
        {
            to: "/logout",
            title: "Logout",
            is_logged_in: true
        },
    ];

    /**
     * @var state
     * @type {{showOnMobile: boolean}}
     */
    state = {
        showOnMobile: false,
    }

    /**
     * @method render
     * @returns {JSX.Element}
     */
    render() {
        const { showOnMobile } = this.state;

        return (
            <div className={ `
                bg-white bg-opacity-30 text-white px-8 py-10 select-none  mb-4 flex flex-row
            ` }>
                <div className="flex flex-row items-center justify-center w-full">
                    <div className={ `${ showOnMobile ? 'hidden' : 'hidden lg:flex-1' }`}></div>
                    <div
                        className={ `${ showOnMobile ? 'flex flex-col' : 'flex flex-row' }
                        justify-center items-center`}
                    >
                        <div className={ `
                            ${ showOnMobile ? 'flex flex-row mb-5' : 'hidden lg:flex' }
                            lg:flex-col lg:items-end p-2 lg:p-0
                        ` }>
                            <div
                                className="flex flex-col lg:flex-row justify-center items-center gap-4 lg:gap-8 text-center">
                                { filterItemsByAccess(this.navItemsLeft).map((navItem, i) =>
                                    this.renderNavItem(navItem, i))
                                }
                            </div>
                        </div>

                        <div>
                            <Link to="/dashboard" className="mx-10 block w-40">
                                <img src={ asset('images/logo.png') } className="w-40" />
                            </Link>
                        </div>

                        <div className={ `
                                ${ showOnMobile ? 'flex mt-5' : 'hidden lg:flex' }
                                flex-col lg:items-end p-2 lg:p-0 w-full mr-0 lg:mr-5
                            ` }>
                            <div
                                className="flex flex-col lg:flex-row justify-center items-center gap-4 lg:gap-8 text-center">
                                { filterItemsByAccess(this.navItemsRight).map((navItem, i) =>
                                    this.renderNavItem(navItem, i))
                                }

                                {/*{User?.data?.is_admin && window.base.features.groups &&*/ }
                                {/*    <AdminGroupSelect/>*/ }
                                {/*}*/ }
                            </div>
                        </div>
                    </div>
                    <div  className={ `${ showOnMobile ? 'hidden' : 'hidden lg:flex-1' }`}>
                        <img src={ asset('images/header-logo.png') } className={ "h-12 ml-auto" }/>
                    </div>
                </div>
                <FontAwesomeIcon
                    icon={ faBars }
                    size="2x"
                    onClick={ () => this.setState({ showOnMobile: !showOnMobile }) }
                    className="absolute lg:hidden cursor-pointer ml-auto mr-2 right-5"
                />
            </div>
        );
    }

    /**
     * @method renderNavItem
     * @param {object} navItem
     * @param {integer} key
     * @returns {JSX.Element}
     */
    renderNavItem = (navItem, key) => {
        return (
            <div key={ key }>
                <NavLink
                    className="flex flex-row justify-center items-center text-md gap-2 text-black whitespace-nowrap font-bold"
                    activeClassName="border-b-2 border-app-primary"
                    to={ navItem.to }
                    exact={ true }
                >
                    { navItem.icon &&
                        <FontAwesomeIcon
                            icon={ navItem.icon }
                            size="1x"
                        />
                    }

                    { navItem.title }
                </NavLink>
            </div>
        );
    };
}

export default withRouter(Header);
